module.exports = __webpack_public_path__ + "media/avio_LOGO_animation.4cfef0ce.mp4";